import React, { useEffect, useState } from 'react';

import './PaginationWithTable.scss';

export default function PaginationWithTable(
    {
        records,
        TableComponent,
        recordsPerPage = 9,
    }
) {

    const [currentRecords, setCurrentRecords] = useState([])
    const [currentPage, setCurrentPage] = useState(1)
    // const [recordsPerPage, setRecordsPerPage] = useState(6);

    const nPages = records?.length > 0 ? Math.ceil(records?.length / recordsPerPage) : 0
    const pageNumbers = records?.length > 0 ? [...Array(nPages + 1).keys()].slice(1) : []

    useEffect(() => {

        setCurrentPage(1)

    }, [records]);

    useEffect(() => {

        if (records?.length > 0) {

            const indexOfLastRecord = currentPage * recordsPerPage;
            const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
            const currentRecords = records.slice(indexOfFirstRecord, indexOfLastRecord);

            setCurrentRecords(currentRecords)
        }

    }, [records, currentPage]);


    const getPages = () => {

        if (currentPage < 5) {

            return pageNumbers.slice(0, 5);

        } else if (currentPage < nPages - 2) {

            return pageNumbers.slice(currentPage - 3, currentPage + 2);
        } else {

            return pageNumbers.slice(nPages - 5, nPages);
        }
    }

    let pageNumbersDisplay = getPages();

    const nextPage = () => {
        if (currentPage < nPages) {

            setCurrentPage(currentPage + 1);
        }
    }

    const previousPage = () => {
        if (currentPage !== 1) {
            setCurrentPage(currentPage - 1);
        }
    }

    return (
        <>
            { TableComponent && <TableComponent data={ currentRecords }/> }

            { records?.length > recordsPerPage && (

                <div className='mt-5 d-flex justify-content-end'>
                    <nav aria-label="Page navigation pagination">
                        <ul className="pagination">

                            <li className={ `page-item ${ currentPage === 1 && 'disabled' }` }>
                                <a
                                    className={ `page-link ${ currentPage === 1 && 'disabled page-link-disabled' }` }
                                    onClick={ previousPage }
                                >
                                    Précédent
                                </a>
                            </li>

                            <li key={ 1 }
                                className={ `page-item ${ currentPage === 1 && 'active' }` }>
                                <a
                                    className="page-link"
                                    onClick={ () => setCurrentPage(1) }>
                                    { 1 }
                                </a>
                            </li>

                            { currentPage - 5 >= 0 && (
                                <li className="page-item">
                                    <a
                                        className="page-link"
                                        onClick={ () => setCurrentPage(currentPage - 5) }
                                        aria-disabled={ currentPage === nPages && true }>
                                        ...
                                    </a>
                                </li>
                            ) }

                            { pageNumbersDisplay.map(pageNumber => {

                                if (pageNumber !== 1 && pageNumber !== nPages) {
                                    return (
                                        <li key={ pageNumber }
                                            className={ `page-item ${ currentPage === pageNumber && 'active' }` }>
                                            <a className="page-link"
                                               onClick={ () => setCurrentPage(pageNumber) }>
                                                { pageNumber }
                                            </a>
                                        </li>
                                    )
                                }
                            }) }

                            { currentPage + 5 < nPages && (
                                <li className="page-item">
                                    <a
                                        className="page-link"
                                        onClick={ () => setCurrentPage(currentPage + 5) }
                                        aria-disabled={ currentPage === nPages && true }>
                                        ...
                                    </a>
                                </li>
                            ) }

                            { nPages !== 1 && (
                                <li key={ nPages }
                                    className={ `page-item ${ currentPage === nPages && 'active' }` }>
                                    <a className="page-link"
                                       onClick={ (e) => {
                                           e.preventDefault()
                                           setCurrentPage(nPages)
                                       } }>
                                        { nPages }
                                    </a>
                                </li>
                            ) }

                            <li className={ `page-item ${ currentPage === nPages && 'disabled' }` }>
                                <a
                                    className={ `page-link ${ currentPage === nPages && 'disabled page-link-disabled' }` }
                                    onClick={ (e) => {
                                        e.preventDefault();
                                        nextPage();
                                    } }
                                    aria-disabled={ currentPage === nPages && true }>
                                    Suivant
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>
            ) }
        </>
    )
}